import type { ReactNode, ThHTMLAttributes } from 'react';
import { IconeSeta } from '../Icones.js';

/**
 * Tabela institucional: cabecalho em faixa, linhas finas, numeros a direita.
 *
 * `empilhar`: no celular cada linha vira um cartao (ver .tabela-empilhada em
 * styles.css). A primeira celula e o titulo, `data-rotulo` marca os detalhes
 * que continuam visiveis e `data-acao` a acao da linha.
 */
export function Tabela({ children, rotulo, empilhar = false }: { children: ReactNode; rotulo: string; empilhar?: boolean }) {
  return (
    <div className="overflow-x-auto">
      <table aria-label={rotulo} className={`w-full border-collapse text-sm ${empilhar ? 'tabela-empilhada' : ''}`}>
        {children}
      </table>
    </div>
  );
}

export const classeTh =
  'h-9 border-b border-borda-forte bg-superficie-2 px-3 text-left text-xs font-semibold tracking-wide whitespace-nowrap text-apagado uppercase';
export const classeTd = 'border-b border-borda px-3 py-2 align-middle';

export type Direcao = 'asc' | 'desc';

/** Cabecalho ordenavel: clicar alterna asc/desc; aria-sort diz o estado. */
export function ThOrdenavel({
  children,
  ativo,
  direcao,
  onOrdenar,
  alinhar = 'esquerda',
  ...p
}: ThHTMLAttributes<HTMLTableCellElement> & {
  children: ReactNode;
  ativo: boolean;
  direcao: Direcao;
  onOrdenar: () => void;
  alinhar?: 'esquerda' | 'direita';
}) {
  return (
    <th
      scope="col"
      aria-sort={ativo ? (direcao === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={`${classeTh} p-0 ${alinhar === 'direita' ? 'text-right' : ''}`}
      {...p}
    >
      <button
        type="button"
        onClick={onOrdenar}
        className={`inline-flex h-9 min-h-0 w-full pointer-coarse:h-11 items-center gap-1 px-3 font-semibold uppercase hover:text-texto ${
          alinhar === 'direita' ? 'justify-end' : ''
        } ${ativo ? 'text-texto' : ''}`}
      >
        {children}
        <IconeSeta
          width={14}
          height={14}
          direcao={ativo && direcao === 'asc' ? 'cima' : 'baixo'}
          className={ativo ? 'opacity-100' : 'opacity-30'}
        />
      </button>
    </th>
  );
}
